import { render, staticRenderFns } from "./EMelderComponentMeldenBs2EingabeTextKurz.vue?vue&type=template&id=78fec0fc"
import script from "./EMelderComponentMeldenBs2EingabeTextKurz.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldenBs2EingabeTextKurz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports